<!-- @veltra/icons generated sha256:0ec29ee8312ee6f5 gen:8 source:src/svg/normal/rotation.svg -->
<script setup lang="ts">
defineOptions({ name: 'Rotation' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M2.504 2c.268 0 .496.224.496.5v5.583A6.005 6.005 0 0 1 7.917 13H13.5c.276 0 .5.228.5.504a.494.494 0 0 1-.49.496H3a1 1 0 0 1-1-1V2.49c0-.275.228-.49.504-.49M6.9 13A5.01 5.01 0 0 0 3 9.1V13z"
    />
  </svg>
</template>
